// javascript

//top heroのスライダー ===================================
let swiper2 = new Swiper('#swiper_hero', {  //スライダーのコンテナ要素の id で初期化
  loop: true,
    speed:900,
  spaceBetween: 30,
    autoplay: {
     delay: 6000,
     disableOnInteraction: false
    },
  pagination: {  //ページネーションを表示
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + '<svg width="40" height="40">'+'<circle class="circle_base" cx="20" cy="20" r="19" />'+'<circle class="circle_animation" cx="20" cy="20" r="19" />'+'</svg>'+'<span class="' + 'circle-inner' + '">' +'0' + (index + 1)+ '</span>' + '</span>';
    },
  },
});


//トップページのニューススライダー ===================================



//conceptスライダー ===================================
let swiper3 = new Swiper('#concept__slider', {  //スライダーのコンテナ要素の id で初期化
  loop: true,
    speed:1100,
    autoplay: {
     delay: 3000,
     disableOnInteraction: false
    },
});

//conceptスライダー ===================================
let swiper4 = new Swiper('#about_intro', {  //スライダーのコンテナ要素の id で初期化
  loop: true,
  effect:  'fade', //フェードのエフェクト
   fadeEffect: {
        crossFade: true
    },
    speed:2000,
    autoplay: {
     delay: 3000,
     disableOnInteraction: false
    },
});


